// export const FilterData = {
//   chats: [
//     { label: "All" },
//     { label: "Latest profiles" },
//     { label: "Premium profiles" },
//     { label: "Verified profiles" },
//   ],
//   // calls: [
//   //   {
//   //     title: "Calls",
//   //     data: [
//   //       { label: "All" },
//   //       { label: "Missed calls" },
//   //       { label: "Received calls" },
//   //     ],
//   //   },
//   //   {
//   //     title: "Profiles",
//   //     data: [
//   //       { label: "All" },
//   //       { label: "Rejected" },
//   //       { label: "Latest profiles" },
//   //       { label: "Premium profiles" },
//   //       { label: "Verified profiles" },
//   //     ],
//   //   },
//   // ],
//   requests: [
//     { label: "All" },
//     { label: "Rejected" },
//     { label: "Latest profiles" },
//     { label: "Premium profiles" },
//     { label: "Verified profiles" },
//   ],
// };

export const FilterData = {
  chats: [
    { label: "All", value: null },
    { label: "Latest profiles", value: 1 },
    { label: "Premium profiles", value: 2 },
    { label: "Verified profiles", value: 3 },
  ],
  requests: [
    { label: "All", value: null },
    { label: "Rejected", value: 4 },
    { label: "Latest profiles", value: 1 },
    { label: "Premium profiles", value: 2 },
    { label: "Verified profiles", value: 3 },
  ],
};

export const segmentData = {
  chats: [
    { label: "All", key: "all" },
    { label: "Unread", key: "unread" },
    { label: "Favourite", key: "favourite" },
  ],
  // calls: [
  //   { label: "All", key: "all" },
  //   { label: "Voice", key: "voice" },
  //   { label: "Video", key: "video" },
  // ],
  requests: [
    { label: "Chats", key: "Chat" },
    // { label: "Calls", key: "Call" },
    // { label: "Calls", key: "Call" },
  ],
};
